import { api } from '@src/constants/api';
import { createMiddleware, Next, regularErrorHandling } from '@src/utils';
import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';

export const createPolicyEngineMiddleware = (http: any, successPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [policyEngineActions.GET_POLICIES_ACTIONS]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: 'GET', url: `${restServiceUrl}Policies/PolicyActions` });
                const data = response.data;
                next({ type: policyEngineActions.GET_POLICIES_ACTIONS, payload: { policies_actions: data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.GET_POLICIES_ENUMS]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: 'GET', url: `${restServiceUrl}PoliciesGeneralParams` });
                const data = response.data;
                next({ type: policyEngineActions.GET_POLICIES_ENUMS, payload: { policies_meta_data: data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.GET_POLICIES_RULES]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: 'GET', url: `${restServiceUrl}Rules/Category` });
                next({ type: policyEngineActions.GET_POLICIES_RULES, payload: { policies_rules: response.data } });
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.GET_POLICIES_RULE_DETAILS]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: 'GET', url: `${restServiceUrl}Rules/${action.payload.ruleId}` });
                next({ type: policyEngineActions.GET_POLICIES_RULE_DETAILS, payload: { policies_rule_data: response.data } });
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.DELETE_RULE]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: 'DELETE', url: `${restServiceUrl}Rules/${action.payload.ruleId}` });
                next({ type: policyEngineActions.DELETE_POLICY_RULE, payload: { policies_rules: response.data } });
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.DELETE_POLICY_RULE]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: 'DELETE', url: `${restServiceUrl}Rules/${action.payload.ruleId}` });
                next({ type: policyEngineActions.DELETE_POLICY_RULE, payload: { policies_rules: response.data } });
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.ADD_POLICY_RULE]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: 'post', data: action.payload.params.internalRule, url: `${restServiceUrl}Rules` });
                if (response.data) {
                    successPopUp();
                    next({ type: policyEngineActions.ADD_POLICY_RULE, payload: { /*policies_rules: resp.data*/ } });
                }
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.EDIT_POLICY_RULE]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: 'put', data: action.payload.params, url: `${restServiceUrl}Rules/${action.payload.ruleId}` });
                if (response.data) {
                    successPopUp();
                    next({ type: policyEngineActions.EDIT_POLICY_RULE, payload: { /*policies_rules: resp.data*/ } });
                }
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.GET_POLICIES]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "GET", url: `${restServiceUrl}policies` });
                next({ type: policyEngineActions.GET_POLICIES, payload: { policies: response.data } });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.GET_POLICIE_DETAILS]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "GET", url: `${restServiceUrl}policies/${action.payload.policyId}` });
                next({ type: policyEngineActions.GET_POLICIE_DETAILS, payload: { policy: response.data } });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.GET_ALL_CATEGORIES_WITH_RULE]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "GET", url: `${restServiceUrl}Categories` });
                next({ type: policyEngineActions.GET_ALL_CATEGORIES_WITH_RULE, payload: { categoriesWithRule: response.data } });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.DELETE_POLICY]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "DELETE", url: `${restServiceUrl}Policies/${action.payload.policyId}` });
                next({ type: policyEngineActions.DELETE_POLICY });
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.ADD_POLICY]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "POST", url: `${restServiceUrl}Policies`, data: action.payload.policyData });
                if (response.data) {
                    successPopUp();
                    next({ type: policyEngineActions.ADD_POLICY });
                }
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.SAVE_POLICY]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "PUT", url: `${restServiceUrl}Policies/${action.payload.policyId}`, data: action.payload.policyData });
                if (response.data) {
                    successPopUp();
                    next({ type: policyEngineActions.SAVE_POLICY });
                }
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.DUPLICATE_POLICY_RULE]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "POST", url: `${restServiceUrl}Rules/Duplicate/${action.payload.ruleId}` });
                if (response.data) {
                    successPopUp();
                    next({ type: policyEngineActions.DUPLICATE_POLICY_RULE });
                }
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.DUPLICATE_POLICY]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "POST", url: `${restServiceUrl}Policies/Duplicate/${action.payload.policyDataId}` });
                next({ type: policyEngineActions.DUPLICATE_POLICY });
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.GET_SCOPES]: async (action: any, next: Next) => {
            try {
                const response = await http({ method: "GET", url: `${restServiceUrl}PoliciesScopes` });
                next({ type: policyEngineActions.GET_SCOPES, payload: { scopes: response.data } });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.GET_SCOPE_DETAILS]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}PoliciesEnforcement/scopeTypeId/${action.payload.typeId}/scopeId/${action.payload.scopeId}`;
                const response = await http({ method: "GET", url: url });
                next({ type: policyEngineActions.GET_SCOPE_DETAILS, payload: { scopeDetails: response.data } });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [policyEngineActions.SAVE_ENFORCEMENT]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}PoliciesEnforcement/scopeTypeId/${action.payload.scopeTypeId}/scopeId/${action.payload.scopeId}`;
                const response = await http({ method: "PUT", url: url, data: action.payload.enforcementData });
                if (response.data) {
                    successPopUp();
                    next({ type: policyEngineActions.SAVE_ENFORCEMENT });
                }
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/policy-engine.middleware.ts